import React, { Component } from 'react'
import { connect } from 'react-redux'
import { change, destroy } from 'redux-form'
import { parseQueryForDisplay, stringifyQuery } from '../../helpers/queryHelper'
import { History } from 'history'

export type Callback<T = void> = (...args: any) => T

import UserFilterForm from './userFilterForm'
export interface Props {
  change: Callback
  destroy: Callback
  history: History
  location: Location
}

export class UserFilter extends Component<Props> {
  onSubmit = (values) => {
    const { history } = this.props
    const withDefaults = Object.assign({}, values, {
      offset: 0,
      limit: 25,
    })
    history.push({
      pathname: '/users',
      search: stringifyQuery(withDefaults),
    })
  }

  cancel = () => {
    const {
      history,
      location: { search },
    } = this.props
    history.push({
      pathname: '/users',
      search,
    })
  }

  destroy = () => {
    const {
      change,
      destroy,
      history,
      location: { search },
    } = this.props
    destroy('userFilterForm')
    const valueArray = Object.keys(parseQueryForDisplay(search))
    valueArray.forEach((value) => {
      change('userFilterForm', value, null)
    })
    history.push({
      pathname: '/users',
    })
  }

  initialValues = () => {
    const { location } = this.props
    return parseQueryForDisplay(location.search)
  }

  render() {
    return (
      <div className="index-filter">
        <h1 className="index-filter__header">Filters</h1>
        <UserFilterForm
          onSubmit={this.onSubmit}
          initialValues={this.initialValues()}
          cancel={this.cancel}
          clear={this.destroy}
          clearFields={this.destroy}
        />
      </div>
    )
  }
}

export default connect(null, {
  change,
  destroy,
})(UserFilter)
